import closeAllMenus from '../../core/INF-closeAllMenus';
import openModal from './openModal';

export default function () {
  // Do we need to close a modal?
  const openModalElement = document.querySelector('[data-modal].Modal--open');
  if (openModalElement && openModalElement.id !== window.location.hash.slice(1)) {
    closeAllMenus();
    document.dispatchEvent(new Event('scroll'));
  }

  // Do we need to open a modal?
  // Also make sure the hash is alpha-numeric + underscore + hyphen, otherwise it's not a valid ID
  if (window.location.hash && window.location.hash !== '' && /^[a-zA-Z0-9_-]*$/.test(window.location.hash.slice(1))) {
    const modal = document.querySelector(`[data-modal]${window.location.hash}`);

    if (modal && !modal.classList.contains('Modal--open')) {
      openModal(modal);
    }
  }
}
